import type { JSX } from 'preact';
import { route } from '@/state/nav';
import { TabBar } from '@/components/TabBar';
import { ToastHost, SheetHost, DialogHost, SunsetPill, OfflineBanner } from '@/components/Overlays';
import { ChatScreen } from '@/screens/Chat';
import { NowScreen } from '@/screens/Now';
import { CalendarScreen } from '@/screens/Calendar';
import { MoreScreen } from '@/screens/More';
import { SignInScreen } from '@/screens/SignIn';
import { RosterScreen } from '@/screens/Roster';
import { RosterDetailScreen } from '@/screens/RosterDetail';
import { AddAnimalScreen } from '@/screens/AddAnimal';
import { HistoryScreen } from '@/screens/History';
import { PhotoLogScreen } from '@/screens/PhotoLog';
import { ReportsScreen } from '@/screens/Reports';
import { ReportOutputScreen } from '@/screens/ReportOutput';
import { SettingsScreen } from '@/screens/Settings';
import { OnboardingScreen } from '@/screens/Onboarding';
import { dataReady, profile } from '@/state/data';
import { useState } from 'preact/hooks';
import { overdueCount } from '@/state/board';
import { session } from '@/lib/supabase';

const SCREENS: Record<string, () => JSX.Element> = {
  chat: ChatScreen,
  now: NowScreen,
  calendar: CalendarScreen,
  more: MoreScreen,
  roster: RosterScreen,
  'roster-detail': RosterDetailScreen,
  'add-animal': AddAnimalScreen,
  history: HistoryScreen,
  photos: PhotoLogScreen,
  reports: ReportsScreen,
  'report-output': ReportOutputScreen,
  settings: SettingsScreen,
};

export function App() {
  const s = session.value;
  const [onboarded, setOnboarded] = useState(localStorage.getItem('tend.onboarded') === '1');
  if (s === undefined) return <div class="app-root" />; // restoring session
  if (s === null) {
    return (
      <div class="app-root">
        <SignInScreen />
      </div>
    );
  }

  if (!onboarded && dataReady.value && !profile.value?.display_name) {
    return (
      <div class="app-root">
        <OnboardingScreen onDone={() => setOnboarded(true)} />
      </div>
    );
  }

  const r = route.value;
  const Screen =
    r.name === 'roster-detail' && r.query.get('edit')
      ? AddAnimalScreen
      : (SCREENS[r.name] ?? ChatScreen);
  const showTabBar = r.tab && ['chat', 'now', 'calendar', 'more'].includes(r.name);
  return (
    <div class="app-root">
      <Screen key={r.name + (r.params.id ?? '') + (r.query.get('edit') ?? '')} />
      {showTabBar && <TabBar overdueDot={overdueCount.value > 0} />}
      <SunsetPill />
      <OfflineBanner />
      <ToastHost />
      <SheetHost />
      <DialogHost />
    </div>
  );
}
